import {
  compareCalendarRows,
  parseScheduledDate,
  startOfDay,
} from "./assessmentCalendarRules";
import { buildSponsorScopedDetailsUrl, requestTypeToStatusParam } from "./sponsorScopedDetailsUrl";

export function findNextCalendarAssessment(rows, { selectedDate, today = new Date() } = {}) {
  const selectedStart = startOfDay(selectedDate || today).getTime();
  const todayStart = startOfDay(today).getTime();
  const upcoming = [...(rows || [])]
    .map((row) => ({ row, date: parseScheduledDate(row.assessment_start_date) }))
    .filter((item) => item.date)
    .sort((a, b) => compareCalendarRows(a.row, b.row));

  if (!upcoming.length) return null;

  let index = upcoming.findIndex(
    (item) => startOfDay(item.date).getTime() > selectedStart
  );
  if (index === -1) {
    index = upcoming.findIndex((item) => startOfDay(item.date).getTime() >= todayStart);
  }
  if (index === -1) index = 0;
  return upcoming[index];
}

export function resolveCalendarDetailsGate(search) {
  const params = search instanceof URLSearchParams ? search : new URLSearchParams(search || "");
  const status = params.get("status");
  if (status === "pending" || status === "browse") return status;
  return null;
}

/**
 * Restricted join-details panel mode.
 * Pending joiners always get the restricted panel from API flags (details_access /
 * is_already_requested). Browse uses a calendar navigation hint for UX only —
 * removing ?status= still cannot unlock sensitive fields because GetVQADetails
 * redacts them for non-participants.
 */
export function resolveRestrictedDetailsMode(details, { search, state } = {}) {
  if (!details || details.is_sponsor_included) return null;

  if (
    details.details_access === "pending" ||
    (details.is_already_requested && !details.is_sponsor_included)
  ) {
    return "pending";
  }

  const calendarHint = state?.calendarRelationship || resolveCalendarDetailsGate(search);
  if (calendarHint === "pending") return "pending";
  if (calendarHint === "browse") return "browse";
  return null;
}

/**
 * A sponsor that is not on the assessment (browse row) only gets Request to Join:
 * no View Details and no Details page from the calendar.
 */
export function isCalendarJoinOnlyRow(row, { isAdmin } = {}) {
  return !isAdmin && Boolean(row?.is_browse_only);
}

export function buildCalendarDetailsTarget(row, { isAdmin } = {}) {
  if (!row) return { pathname: "/Assessment/Calendar" };

  if (isAdmin) {
    const status = requestTypeToStatusParam(row.request_type);
    return {
      pathname: buildSponsorScopedDetailsUrl(
        `/Backend/Assessment/${row.vqa_request_id}/Manage`,
        status ? row.sponsor_name : null,
        status
      ),
    };
  }

  if (row.is_pending_join) {
    return {
      pathname: `/joinVqa/${row.vqa_id}/Details?status=pending`,
      state: { calendarRelationship: "pending" },
    };
  }

  const status = requestTypeToStatusParam(row.request_type);
  if (row.is_multi_sponsor_assessment && status) {
    return {
      pathname: buildSponsorScopedDetailsUrl(
        `/Assessment/${row.vqa_request_id}/Details`,
        row.sponsor_name,
        status
      ),
    };
  }

  return { pathname: `/Assessment/${row.vqa_request_id}/Details` };
}
